import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'text-header',
  imports: [CommonModule],
  templateUrl: './text-header.component.html',
  styleUrl: './text-header.component.scss',
})
export class TextHeaderComponent {
  @Input() accent? = false;
}
